/* eslint-disable import/no-extraneous-dependencies */
import 'jquery-ui/ui/widgets/dialog';
import 'notifyjs-browser';
import View from './View';
import '../../common/binary-ui/dropdown';
import Elevio from '../../common/elevio';
import GTM from '../../common/gtm';
import { isBinaryDomain, isProduction } from '../../common/utils/tools';

$.ajaxSetup({
    cache: false,
});

// eslint-disable-next-line no-underscore-dangle
// window._trackJs = {
//     token      : process.env.TRACKJS_TOKEN,
//     application: 'binary-bot',
//     enabled    : isProduction(),
//     console    : {
//         display: false,
//     },
// };

// Should stay below the window._trackJs config
// require('trackjs');

const view = new View();

view.initPromise.then(() => {
    $('.show-on-load').show();
    $('.show-on-load-flex').css('display', 'flex');
    $('.barspinner').hide();
    window.dispatchEvent(new Event('resize'));
    // GTM.init();
});

// if (!isBinaryDomain) {
//     // eslint-disable-next-line no-unused-expressions
//     document.getElementsByClassName('dbot-banner__separator')[0]?.remove();
//     // eslint-disable-next-line no-unused-expressions
//     document.getElementById('logo')?.remove();
// }



// WEBPACK FOOTER //
// ./src/botPage/view/index.js